/**
 * @param fieldName {string}
 * @returns {string | undefined}
 */
module.exports = function convertRoiCalculatorFieldNameToGoogleAnalyticsEventName(fieldName) {
    const fieldMapping = {
        "wvc_Industry": "ROI_Industry",
        "wvc_EvaluatingMultipleChannels": "ROI_MultiChannel",
        "wvc_UniqueSiteVisitors": "ROI_UniqueVisitors",
        "wvc_TotalMarketingSubscribers": "ROI_Subscribers",
        "wvc_AnnualSendVolume": "ROI_SendVolume",
        "wvc_TriggeredEventRate": "ROI_BlastPercent",
        "wvc_AnnualMarketingRevenue": "ROI_MarketingRev",
        "wvc_AverageOrderValue": "ROI_AOV",
        "wvc_AnnualChurnRate": "ROI_Churn",
        "wvc_TotalCampaignMarketers": "ROI_MarketerHC",
        "wvc_TotalEngineeringMarketers": "ROI_EngHC",
    };

    return fieldMapping[fieldName];
}
